import Image from 'next/legacy/image'
import styled from 'styled-components'

import { tokens } from '@JOTAJornalismo/jota-design-system'
import { ButtonDS } from '../geral/JOTADS.components'
import router from 'next/router'
import { MD_PX, SM_PX } from '../header/Header.styled'
const { colors, fonts } = tokens

const Error404 = () => {
    return (
        <Body>
            <Container>
                <ImageContainer>
                    <Image
                        src={'/images/logo-jota-error.svg'}
                        layout='responsive'
                        width={210}
                        height={230}
                        alt='Error'
                    />
                </ImageContainer>

                <TextContainer>
                    <Title> Página não encontrada </Title>
                    <ErrorParagraph>
                        Desculpe, essa página não existe ou está indisponível.
                        Verifique se o link está correto ou clique no botão
                        abaixo para voltar para a página inicial
                    </ErrorParagraph>
                    <ButtonDS
                        color='orange'
                        type='filled'
                        label={'Voltar para o início'}
                        size={'medium'}
                        onClick={() => {
                            router.push('/')
                        }}
                    />
                </TextContainer>
            </Container>
        </Body>
    )
}

export default Error404

const Container = styled.div`
    display: grid;
    grid-template-columns: 30% 70%;
    align-items: start;
    align-content: center;
    flex-direction: row;
    justify-content: center;
    width: 675px;
    gap: 60px;
    box-sizing: border-box;

    @media (max-width: ${MD_PX}) {
        grid-template-columns: 1fr;
        gap: 44px;
    }
`
const TextContainer = styled.article`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    max-height: 210px;
    box-sizing: border-box;
    word-break: break all;

    @media (max-width: ${MD_PX}) {
        max-width: 430px;
    }
}
`

const ImageContainer = styled.div`
    margin-right: 60px;
    width: 100%;
    height: auto;

    img {
        width: 100% !important;
        height: auto !important;
    }

    @media (max-width: ${MD_PX}) {
        width: 180px !important;
        height: 203px !important;
    }
`

const Body = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 800px;
    box-sizing: border-box;

    @media (max-width: ${MD_PX}) {
        margin: 124px 36px;
        justify-content: flex-start;
        align-items: flex-start;
    }

    @media (max-width: ${SM_PX}) {
        margin: 88px 16px;
    }
`

const ErrorParagraph = styled.p`
    ${fonts.jotaBody()};
    color: ${colors.gray.jotaGrayDark};
    margin: 0 0 44px 0;
`

const Title = styled.h2`
    ${fonts.jotaHeading03()};
    color: ${colors.black.jotaBlack};
    margin: 0 0 8px 0;
    width: 100%;
`
